import {
  AHIcon,
  AHText,
  Box,
  Circle,
  ColorType,
  Space,
  TouchableBox,
  useLayoutContext,
} from "arkh";
import React from "react";
import { Platform } from "react-native";

export function LinkedItemTitle(props: { children: React.ReactNode }) {
  return (
    <AHText type="subtitle" numberOfLines={1} ellipsizeMode="tail">
      {props.children}
    </AHText>
  );
}
export function LinkedItemSubtitle(props: { children: React.ReactNode }) {
  return <AHText>{props.children}</AHText>;
}

function UnlinkButton(props: { onPress: () => void }) {
  return (
    <TouchableBox
      onPress={props.onPress}
      style={{
        height: "100%",
        justifyContent: "center",
        alignSelf: "flex-end",
      }}
      spaceLeft="small"
    >
      <Circle color="surface-backgroundControl" size="smallMedium">
        <AHIcon type="clear" forceSize={13} />
      </Circle>
    </TouchableBox>
  );
}

function UnlinkButtonWeb(props: { onPress: () => void }) {
  const layout = useLayoutContext();
  return (
    <TouchableBox
      style={{
        position: "absolute",
        top: -layout.circle.smallMedium / 3,
        right: -layout.circle.smallMedium / 3,
        width: layout.circle.smallMedium,
        height: layout.circle.smallMedium,
        borderRadius: layout.circle.smallMedium / 2,
        justifyContent: "center",
        alignItems: "center",
      }}
      color="surface-backgroundControl"
      onPress={props.onPress}
    >
      <AHIcon type="clear" forceSize={13} />
    </TouchableBox>
  );
}

export const LINKED_ITEM_CONTAINER_HEIGHT = 60;

export function LinkedItemContainer(props: {
  children: React.ReactNode;
  onPress: () => void;
  onRemove?: () => void;
  space?: Space;
  borderColor?: ColorType;

  disabled?: boolean;
}) {
  return (
    <Box style={{ flex: 1 }}>
      <TouchableBox
        style={{
          flexDirection: "row",
          alignItems: "center",
          borderWidth: 1,
          flex: 1,

          overflow: "hidden",
        }}
        borderColor={props.borderColor ?? "border-primary"}
        space={props.space ?? "small"}
        spaceHorizontal="medium"
        cornerRadius="large"
        onPress={props.onPress}
        disabled={props.disabled}
      >
        {props.children}
        {Platform.OS !== "web" && props.onRemove && !props.disabled ? (
          <UnlinkButton onPress={props.onRemove} />
        ) : null}
      </TouchableBox>
      {Platform.OS === "web" && props.onRemove && !props.disabled ? (
        <UnlinkButtonWeb onPress={props.onRemove} />
      ) : null}
    </Box>
  );
}
